import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=dd385afa&scoped=true&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"
import style0 from "./_Form.vue?vue&type=style&index=0&id=dd385afa&prod&scoped=true&lang=scss&"
import style1 from "./_Form.vue?vue&type=style&index=1&id=dd385afa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd385afa",
  null
  
)

export default component.exports